var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 201,
    viewBox: "0 0 288 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.3032 0.05896L96.3032 200.059",
    stroke: "url(#paint0_linear_582_3248)",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.043 0.05896L144.043 200.059",
    stroke: "url(#paint1_linear_582_3248)",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.824471 0.05896L0.824462 200.059",
    stroke: "url(#paint2_linear_582_3248)",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.564 0.05896L48.564 200.059",
    stroke: "url(#paint3_linear_582_3248)",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.782 0.05896L191.782 200.059",
    stroke: "url(#paint4_linear_582_3248)",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.521 0.05896L239.521 200.059",
    stroke: "url(#paint5_linear_582_3248)",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.261 0.05896L287.261 200.059",
    stroke: "url(#paint6_linear_582_3248)",
    strokeWidth: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_582_3248",
    x1: 0,
    y1: 0,
    x2: -0.00195312,
    y2: 48061.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0867447,
    stopColor: "#343440",
    stopOpacity: 0.651685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2141C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#343440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#DD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C21",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLines);
export default __webpack_public_path__ + "static/media/Vertical-lines.70a07b78.svg";
export { ForwardRef as ReactComponent };